import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const footerLinks = [
    {
      title: "Main Links",
      links: [
        { name: "Home", url: "/" },
        { name: "Placement", url: "/placement" },   // lowercase
        { name: "Gallery", url: "/gallery" },
        { name: "Contact", url: "/contact" }
      ]
    },
    {
      title: "About RDS",
      links: [
        { name: "Vision & Mission", url: "/vision" },
        { name: "University", url: "/university" },
        { name: "Principal's Message", url: "/principal-message" },
        { name: "Chairman's Message", url: "/chairman" }
      ]
    },
    {
      title: "Courses",
      links: [
        { name: "B. Pharma", url: "/bpharma" },
        { name: "D. Pharma", url: "/dpharma" },     // corrected
        { name: "Fee Structure", url: "/fee-structure" }
      ]
    },
    {
      title: "Admission",
      links: [
        { name: "Registration Form", url: "/resistration" },  
        { name: "Prospectus", url: "/prospectus" },
        { name: "RDS Affiliation", url: "/affiliation" },      
        { name: "Pharmacy Schedule", url: "/pharmacy" },       
        { name: "Committee", url: "/committee" }
      ]
    }
  ];
  return (
    <footer className="bg-gradient-to-r from-sky-500 to-sky-700 text-white w-full overflow-x-hidden">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 border-b border-white/30 pb-6">
          <div className="flex items-center justify-center w-full sm:w-auto">
            <img
              src="/logo.jpeg"
              alt="RDS College of Pharmacy"
              className="h-12 sm:h-14 w-auto bg-white p-1.5 rounded-lg shadow-md"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = 'https://via.placeholder.com/60x60?text=RDS';
              }}
            />
          </div>
          <div className="flex flex-wrap justify-center gap-2 sm:gap-4 text-xs sm:text-sm">
            <a href="privacy-policy" className="text-white hover:text-sky-200 transition-colors font-medium">Privacy Policy</a>
            <span className="text-white/50">|</span>
            <a href="terms-of-use" className="text-white hover:text-sky-200 transition-colors font-medium">Terms of Use</a>
            <span className="text-white/50">|</span>
            <a href="sitemap" className="text-white hover:text-sky-200 transition-colors font-medium">Sitemap</a>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 py-6 sm:py-8">
          {footerLinks.map((section, idx) => (
            <div key={idx} className="text-center sm:text-left">
              <h4 className="text-white font-bold text-base mb-3 border-l-3 border-white pl-2 inline-block sm:block">
                {section.title}
              </h4>
              <ul className="space-y-2">
                {section.links.map((link, linkIdx) => (
                  <li key={linkIdx}>
                    <Link
                      to={link.url}
                      className="text-white/90 hover:text-white hover:pl-1 transition-all duration-200 text-sm flex items-center justify-center sm:justify-start gap-1 group"
                    >
                      <span className="text-white/60 group-hover:text-white transition-colors">›</span>
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-white/30 pt-6">
          <div className="flex flex-col lg:flex-row justify-between items-center gap-6">
            <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6 text-white text-sm">
              <div className="flex items-center gap-2">
                <svg className="w-4 h-4 text-white flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span className="font-medium text-center sm:text-left text-xs sm:text-sm">RDS College, Muzaffarnagar, UP, India</span>
              </div>
              <div className="flex items-center gap-2">
                <svg className="w-4 h-4 text-white flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <a href="mailto:rdspharmacycollege@gmail.com" className="font-medium hover:text-sky-200 transition-colors text-xs sm:text-sm break-all">
                  rdspharmacycollege@gmail.com
                </a>
              </div>
              <div className="flex items-center gap-2">
                <svg className="w-4 h-4 text-white flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <div className="flex flex-col items-center sm:items-start">
                  <a href="tel:+919956808612" className="font-medium hover:text-sky-200 transition-colors text-xs sm:text-sm">+91 9956808612</a>
                  <a href="tel:+919628362187" className="font-medium text-xs sm:text-sm hover:text-sky-200 transition-colors">+91 9628362187</a>
                </div>
              </div>
            </div>
            <div className="bg-white/10 rounded-lg px-3 sm:px-4 py-2 w-full sm:w-auto">
              <div className="flex items-center justify-center gap-2">
                <svg className="w-4 h-4 text-white animate-pulse flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <span className="font-semibold text-xs sm:text-sm">ANTI RAGGING:</span>
                <a href="tel:18001805522" className="hover:underline font-mono font-bold text-xs sm:text-sm">1800 180 5522</a>
              </div>
            </div>
            <div className="flex gap-2 sm:gap-3">
              <a href="https://www.facebook.com/rdspharmacy" className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center transition-all duration-300 hover:scale-110" aria-label="Facebook">
                <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.879v-6.99h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.99C18.343 21.128 22 16.991 22 12z" />
                </svg>
              </a>
              <a href="#" className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center transition-all duration-300 hover:scale-110" aria-label="Twitter">
                <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.937 4.937 0 004.604 3.417 9.868 9.868 0 01-6.102 2.104c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 0021.968-12.187c0-.213-.005-.425-.015-.636a10.025 10.025 0 002.457-2.548z" />
                </svg>
              </a>
              <a href="https://www.instagram.com/rdsgroup_of_colleges?igsh=MTNma2x6cTBwdGJwdA==" className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center transition-all duration-300 hover:scale-110" aria-label="Instagram">
                <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.332.014 7.052.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
                </svg>
              </a>
              <a href="#" className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center transition-all duration-300 hover:scale-110" aria-label="LinkedIn">
                <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451c.979 0 1.771-.773 1.771-1.729V1.729C24 .774 23.204 0 22.225 0z" />
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div className="text-center text-white text-xs sm:text-sm pt-6 border-t border-white/30 mt-4">
          <p>Copyright © {currentYear} RDS College of Pharmacy. All Rights Reserved</p>
          <p className="text-white/80 text-xs mt-1">
            Designed & Developed by <span className="font-semibold text-white">RDS College of Pharmacy</span>
          </p>
        </div>
      </div>
      {showScrollTop && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="fixed bottom-4 sm:bottom-6 right-4 sm:right-6 bg-white text-sky-600 p-2 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 z-50"
          aria-label="Scroll to top"
        >
          <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 10l7-7m0 0l7 7m-7-7v18"></path>
          </svg>
        </button>
      )}
    </footer>
  );
};

export default Footer;